export const SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
export const nodeListToArr = (nodeList: NodeList): ChildNode[] => Array.prototype.slice.call(nodeList);
